const DRAFT_PREFIX = 'workstation:agent-chat-draft:v1:'
export const AGENT_CHAT_DRAFT_EVENT = 'agent-chat-draft-change'

export function composerDraftKey(
  userId: number | string,
  workerId: string,
  sessionId: string | null,
): string {
  return `${DRAFT_PREFIX}${userId}:${workerId}:${sessionId || 'new'}`
}

export function readComposerDraft(key: string): string {
  if (typeof window === 'undefined') return ''

  try {
    return window.localStorage.getItem(key) || ''
  } catch {
    return ''
  }
}

export function writeComposerDraft(key: string, text: string): void {
  if (typeof window === 'undefined') return

  try {
    if (text.trim()) window.localStorage.setItem(key, text)
    else window.localStorage.removeItem(key)
    window.dispatchEvent(new CustomEvent(AGENT_CHAT_DRAFT_EVENT, { detail: { key } }))
  } catch {
    // Storage restrictions must never block composing or sending a message.
  }
}

export function hasComposerDraft(
  userId: number | string,
  workerId: string,
  sessionId: string | null,
): boolean {
  return readComposerDraft(composerDraftKey(userId, workerId, sessionId)).trim().length > 0
}
